import { APP_TYPE } from "@src/utils/common";

/**
 * 获取回调地址
 * @param {应用id} appId
 * @returns
 */
export const getCallBack = async (appId, appType) => {
  const callBackUrl = {
    innerapp: 'apps',
    isv: 'isv/apps'
  };
  const res = await fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/${callBackUrl[appType]}/manage/config/${appId}`,
    {method: "GET"}
  );
  if (res && res.status == 1) {
    return {
      configCallbackValue: res.data.callBackUrl
    };
  } else {
    return {};
  }
};

/**
 * 设置配置信息（管理后台地址、回调地址）
 * @param {string} type test:测试，save:保存
 */
export const handleConfigCallbackUrl = ({appId, type, jsonParam, callBackUrl}) => {
  return fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/apps/manage/config/${appId}`,
    {
      method: "POST",
      body: JSON.stringify({
        type,
        jsonParam,
        callBackUrl
      })
    }
  );
};

/**
 * 更新wema配置信息
 * @param {string} type test:测试，save:保存
 */
export const handleUpdateAppConfig = ({appId, type, jsonParam, callBackUrl, appType}) => {
  const fetchUrl = {
    [APP_TYPE.innerapp]: '/service/apps/manage/config',
    [APP_TYPE.isv]: '/service/isv/apps/manage/config'
  }
  return fetch(
    `/${process.env.REACT_APP_API_CONTEXT}${fetchUrl[appType]}/${appId}`,
    {
      method: "POST",
      body: {
        type,
        jsonParam,
        callBackUrl
      }
    }
  );
};
